var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoaded)?_c('div',[_vm._t("default")],2):_c('div',[_c('p',[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }